import { Country } from '~shared/models';
import { CountriesActions, CountriesActionTypes } from './countries.actions';

export interface State {
  countries: Country[];
  loading: boolean;
  error: any;
}

export const initialState: State = {
  countries: [],
  loading: false,
  error: null,
};

export function reducer(state = initialState, action: CountriesActions): State {
  switch (action.type) {
    case CountriesActionTypes.READ_COUNTRIES:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CountriesActionTypes.READ_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload,
        loading: false,
      };

    case CountriesActionTypes.READ_COUNTRIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
